// extracted by mini-css-extract-plugin
export default {"property-breadcrumb":"ContentParameterRegister_property-breadcrumb__BFQRh","propertyBreadcrumb":"ContentParameterRegister_property-breadcrumb__BFQRh"};